import { Grid, Typography } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import { GridButton } from '../shared/GridButton'

const StyledHeading = styled(Typography)`
  && {
    text-transform: uppercase;
    margin-bottom: 10px;
  }
`

const StyledTermsText = styled(Typography)`
  && {
    margin-bottom: 15px;
  }
`

export interface AutoShipTermsProps {
  className?: string
  confirmed: boolean
  onConfirm: () => void
}

const AutoShipTerms: React.FC<AutoShipTermsProps> = ({ className, confirmed, onConfirm }) => (
  <div className={className}>
    <StyledHeading variant="h5">Confirm your Auto-ship Subscription</StyledHeading>
    <StyledTermsText variant="body1">
      By placing your order, you agree to DFH’s Privacy Notice, Terms of Use, and Terms of Sale. You
      also agree to the terms and conditions of our Auto-Ship Program for this subscription and
      authorize us to charge the payment method you used to create this subscription, or another
      payment method as directed by you. Your Auto-Ship subscription will continue until canceled.
      You can cancel at any time through the Site under My Account – Orders – Auto-Ship.
    </StyledTermsText>
    <Grid container justifyContent="center">
      <GridButton
        disabled={confirmed}
        onClick={onConfirm}
        type="button"
        id="auto-ship-terms-accepted-button"
        data-cy="auto-ship-terms-accepted-button"
      >
        {!confirmed ? 'Confirm Subscription' : 'Subscription Confirmed'}
      </GridButton>
    </Grid>
  </div>
)

const StyledAutoShipTerms = styled(AutoShipTerms)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  flex-basis: 100%;
  padding: 15px;

  @media (min-width: 600px) {
    border-left: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-right: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`

export default StyledAutoShipTerms
